import Home from "./admin/pages/home/Home";
import Login from "./admin/pages/login/Login";
import UserList from "./admin/pages/userlist/UserList";
import Single from "./admin/pages/single/Single";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { productInputs, userInputs, newUserInputs } from "./formSource";
import "./style/dark.scss";
import { useContext } from "react";
import { DarkModeContext } from "./context/darkModeContext";
import NewUser from "./admin/pages/usernew/NewUser";
import NewsList from "./admin/pages/newslist/NewsList";
import NewsNew from "./admin/pages/newsnew/NewsNew";
import GharList from "./admin/pages/gharlist/GharList";
import NewGhar from "./admin/pages/gharnew/NewGhar";
import ServiceNew from "./admin/pages/service/ServiceNew";
import store from "./reduxtool/store";
import { Provider } from "react-redux";
import MarketList from "./admin/pages/localmarketlist/MarketList";
import NewMarket from "./admin/pages/localmarketnew/NewMarket";
import TravelList from "./admin/pages/travellist/TravelList";
import NewTravel from "./admin/pages/travelnew/NewTravel";
import EventsList from "./admin/pages/eventslist/EventsList";
import NewEvents from "./admin/pages/eventsnew/NewEvents";
import MemberList from "./admin/pages/memberlist/MemberList";
import NewMember from "./admin/pages/membernew/NewMember";
import SponsorList from "./admin/pages/sponsorlist/SponsorList";
import NewSponsor from "./admin/pages/sponsornew/NewSponsor";
import MelaList from "./admin/pages/melalist/MelaList";
import NewMela from "./admin/pages/melanew/NewMela";
import FinanceList from "./admin/pages/financelist/FinanceList";
import NewFinance from "./admin/pages/financenew/NewFinance";
import FinanceMelaList from "./admin/pages/financemelalist/FinanceMelaList";
import NewFinanceMela from "./admin/pages/financemelanew/NewFinanceMela";
import MeetingList from "./admin/pages/meetinglist/MeetingList";
import NewMeeting from "./admin/pages/meetingnew/NewMeeting";
import GtakList from "./admin/pages/gtaklist/GtakList";
import GtakNew from "./admin/pages/gtaknew/GtakNew";
import PlayGtakVideo from "./admin/pages/play/PlayGtakVideo";
import NoticeList from "./admin/pages/noticelist/NoticeList";
import NewNotice from "./admin/pages/noticenew/NewNotice";

import PeopleList from "./admin/pages/peoplelist/PeopleList";
import PeopleNew from "./admin/pages/peoplenew/NewPeople";

import FinanceReport from "./admin/pages/reports/FinanceReport";
import FinanceMelaReport from "./admin/pages/financemelareport/FinanceMelaReport";
import SponsorReport from "./admin/pages/reports/SponsorReport";
import MemberReport from "./admin/pages/reports/MemberReport";
import EventsReport from "./admin/pages/reports/EventsReport";
import MeetingReport from "./admin/pages/reports/MeetingReport";
import NoticeReport from "./admin/pages/reports/NoticeReport";
import MarketReport from "./admin/pages/reports/MarketReport";
import HomeStayReport from "./admin/pages/reports/HomeStayReport";
import TravelReport from "./admin/pages/reports/TravelReport";
import UserReport from "./admin/pages/reports/UserReport";
import FinanceTollReport from "./admin/pages/tollFinancereport/FinanceTollReport";
import TollActivityReport from "./admin/pages/tollActivityreport/TollActivityReport";

import ProtectedRoute from "./ProtectedRoute";
import NewPeople from "./admin/pages/peoplenew/NewPeople";
import PopulationReport from "./admin/pages/reports/PopulationReport";

import TollList from "./admin/pages/tolllist/TollList";
import NewToll from "./admin/pages/tollnew/NewToll";

import GharNoList from "./admin/pages/gharnolist/GharNoList";
import NewGharNo from "./admin/pages/gharnonew/NewGharNo";

import CustomadsNew from "./admin/pages/adscustomnew/NewCustomAds";
import CustomadsList from "./admin/pages/adscustomlist/CustomAdsList";

function App() {
  const { darkMode } = useContext(DarkModeContext);

  return (
    <div className={darkMode ? "app dark" : "app"}>
      <Provider store={store}>
        <BrowserRouter>
          <Routes>
            <Route path="/">
              <Route index element={<Login />} />
              <Route path="dashboard" element={<Home />} />

              {/* User Routes */}
              <Route path="users">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <UserList />
                    </ProtectedRoute>
                  }
                />
                {/* <Route path=":userId" element={<Single />} /> */}
                <Route
                  path="newUser"
                  element={
                    <ProtectedRoute>
                      <NewUser inputs={newUserInputs} title="Add New User" />
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route path="customads">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <CustomadsList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newCustomAds"
                  element={
                    <ProtectedRoute>
                      <CustomadsNew
                        inputs={newUserInputs}
                        title="Add New Ads"
                      />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* News Routes */}
              <Route path="news">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <NewsList />{" "}
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="newsNew"
                  element={
                    <ProtectedRoute>
                      <NewsNew inputs={newUserInputs} title="Add News" />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* HomeStay Routes */}
              <Route path="ghar">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <GharList />{" "}
                    </ProtectedRoute>
                  }
                />

                <Route
                  path="gharDetail"
                  element={
                    <ProtectedRoute>
                      <ServiceNew />{" "}
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newGhar"
                  element={
                    <ProtectedRoute>
                      <NewGhar inputs={newUserInputs} title="Add Home Stay" />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* Local Market Routes */}
              <Route path="market">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <MarketList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newMarket"
                  element={
                    <ProtectedRoute>
                      <NewMarket
                        inputs={newUserInputs}
                        title="Add Local Product"
                      />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* Videos Routes */}
              <Route path="gtak">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <GtakList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newGtak"
                  element={
                    <ProtectedRoute>
                      <GtakNew inputs={newUserInputs} title="Add Video" />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="playGtak"
                  element={
                    <ProtectedRoute>
                      <PlayGtakVideo title="Playing Video" />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/*travle route Routes */}
              <Route path="travel">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <TravelList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newTravel"
                  element={
                    <ProtectedRoute>
                      <NewTravel
                        inputs={newUserInputs}
                        title="Add Travel Route"
                      />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/*events route Routes */}
              <Route path="events">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <EventsList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newEvents"
                  element={
                    <ProtectedRoute>
                      <NewEvents inputs={newUserInputs} title="Add Event" />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/*people route Routes */}
              <Route path="people">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <PeopleList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newPeople"
                  element={
                    <ProtectedRoute>
                      <NewPeople inputs={newUserInputs} title="Add People" />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Members Routes */}
              <Route path="members">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <MemberList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newMembers"
                  element={
                    <ProtectedRoute>
                      <NewMember
                        inputs={productInputs}
                        title="Add New Member"
                      />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Sponsor Routes */}
              <Route path="sponsor">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <SponsorList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newSponsor"
                  element={
                    <ProtectedRoute>
                      <NewSponsor
                        inputs={productInputs}
                        title="Add New Sponsor"
                      />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Mela Routes */}
              <Route path="mela">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <MelaList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newMela"
                  element={
                    <ProtectedRoute>
                      <NewMela title="Add New Mela" />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Finance Routes */}
              <Route path="finance">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <FinanceList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newFinance"
                  element={
                    <ProtectedRoute>
                      <NewFinance title="Add New Finance" />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Finance Mela Routes */}
              <Route path="financeMela">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <FinanceMelaList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newFinanceMela"
                  element={
                    <ProtectedRoute>
                      <NewFinanceMela title="Add New Finance Mela" />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* Meeting/Activity Routes */}
              <Route path="meeting">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <MeetingList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newMeeting"
                  element={
                    <ProtectedRoute>
                      <NewMeeting title="Add New Meeting/Activity" />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* Notice Routes */}
              <Route path="notice">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <NoticeList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newNotice"
                  element={
                    <ProtectedRoute>
                      <NewNotice title="Add New Notice" />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* Toll Routes */}
              <Route path="toll">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <TollList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newToll"
                  element={
                    <ProtectedRoute>
                      <NewToll title="Add New Toll" />
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route path="gharNo">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <GharNoList />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="newGharNo"
                  element={
                    <ProtectedRoute>
                      <NewGharNo />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* finance report Routes */}
              <Route path="financeReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <FinanceReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* mela Report report Routes */}
              <Route path="melaReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <FinanceMelaReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* sponsor report Routes */}
              <Route path="sponsorReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <SponsorReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* member report Routes */}
              <Route path="memberReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <MemberReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* meeting report Routes */}
              <Route path="meetingReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <MeetingReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* events report Routes */}
              <Route path="eventsReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <EventsReport />
                    </ProtectedRoute>
                  }
                />
              </Route>

              {/* notice report Routes */}
              <Route path="noticeReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <NoticeReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* home report Routes */}
              <Route path="homeStayReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <HomeStayReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* events report Routes */}
              <Route path="travelReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <TravelReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* population report Routes */}
              <Route path="peopleReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <PopulationReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* market report Routes */}
              <Route path="marketReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <MarketReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* users report Routes */}
              <Route path="userReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <UserReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* users report Routes */}
              <Route path="tollActivityReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <TollActivityReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* users report Routes */}
              <Route path="tollActivityReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <TollActivityReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              {/* users report Routes */}
              <Route path="tollFinanceReport">
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <FinanceTollReport />
                    </ProtectedRoute>
                  }
                />
              </Route>
              <Route path="contactInfo">
                <Route
                  index
                  element={
                    // <ProtectedRoute>
                    <Single />
                    // </ProtectedRoute>
                  }
                />
              </Route>

              {/* <Route path="members">
                <Route index element={<List />} />
                <Route path=":productId" element={<Single />} />
                <Route
                  path="new"
                  element={
                    <New inputs={productInputs} title="Add New Product" />
                  }
                />
              </Route> */}
            </Route>
          </Routes>
        </BrowserRouter>
      </Provider>
    </div>
  );
}

export default App;
